const elementExists = document.querySelectorAll('.input-css-search');

Array.from(elementExists).forEach((inputWrap) => {
  inputWrap.querySelector('.search-submit').addEventListener('click', (e) => {
    const { target } = e;
    const form = target.closest('form');
    const input = inputWrap.querySelector('input[name="s"]');

    if (input.value === '' && form.querySelector('.select-css-clearable select').value === '') {
      const postTypeInput = form.querySelector('input[name="post_type"]');
      if (
        postTypeInput !== null &&
        postTypeInput.value !== '' &&
        // eslint-disable-next-line no-undef,camelcase
        typeof deepsea_investments_vars !== 'undefined' &&
        // eslint-disable-next-line no-undef,camelcase
        deepsea_investments_vars.siteUrl !== undefined
      ) {
        // eslint-disable-next-line no-undef,camelcase
        window.location.href = `${deepsea_investments_vars.siteUrl}/insights/`;
        return;
      }
    }

    form.submit();
  });
});

const searchForms = document.querySelectorAll('.post-search.deepsea-form');
if (searchForms.length > 0) {
  Array.from(searchForms).forEach((searchForm) => {
    searchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const { currentTarget: form } = e;
      const input = form.querySelector('input[name="s"]');
      const select = form.querySelector('.select-css-clearable select');

      if (input.value === '' && select !== null && select.value === '') {
        const postTypeInput = form.querySelector('input[name="post_type"]');
        if (
          postTypeInput !== null &&
          postTypeInput.value !== '' &&
          // eslint-disable-next-line no-undef,camelcase
          typeof deepsea_investments_vars !== 'undefined' &&
          // eslint-disable-next-line no-undef,camelcase
          deepsea_investments_vars.siteUrl !== undefined
        ) {
          // eslint-disable-next-line no-undef,camelcase
          window.location.href = `${deepsea_investments_vars.siteUrl}/insights/`;
          return;
        }
      }

      form.submit();
    });
  });
}
